import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerGradleProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
  isBoth?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerGradle: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerGradleProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive,
    isBoth = props.isBoth || false;
  if (isBoth) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="build.gradle" />
        <ArtifactViewCodeDiffDisplay type="normal" text="dependencies {" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={
            '\u2003compile \u0027' +
            component.coordinate1 +
            ':' +
            component.coordinate2 +
            ':' +
            unsafeVersion +
            '\u0027'
          }
        />

        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            '\u2003compile (\u0027' +
            component.coordinate1 +
            ':' +
            component.coordinate2 +
            ':' +
            safeVersion +
            '\u0027) {'
          }
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u2003\u2003force = true'} />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003}'} />

        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="normal" text="}" />
      </div>
    );
  } else if (!transitive) {
    // Direct
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="build.gradle" />
        <ArtifactViewCodeDiffDisplay type="normal" text="dependencies {" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={
            '\u2003compile \u0027' +
            component.coordinate1 +
            ':' +
            component.coordinate2 +
            ':' +
            unsafeVersion +
            '\u0027'
          }
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            '\u2003compile \u0027' +
            component.coordinate1 +
            ':' +
            component.coordinate2 +
            ':' +
            safeVersion +
            '\u0027'
          }
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="normal" text="}" />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="build.gradle" />
        <ArtifactViewCodeDiffDisplay type="add" text="dependencies {" />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            '\u2003compile (\u0027' +
            component.coordinate1 +
            ':' +
            component.coordinate2 +
            ':' +
            safeVersion +
            '\u0027) {'
          }
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u2003\u2003force = true'} />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003}'} />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u2003\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="add" text="}" />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerGradle;
